import '@/App.css';
import Header from '@/components/Header';
import Hero from '@/components/Hero';
import TrustStrip from '@/components/TrustStrip';
import Services from '@/components/Services';
import WhyUs from '@/components/WhyUs';
import Process from '@/components/Process';
import Sectors from '@/components/Sectors';
import Jurisdictions from '@/components/Jurisdictions';
import Technology from '@/components/Technology';
import CtaBanner from '@/components/CtaBanner';
import ContactForm from '@/components/ContactForm';
import Footer from '@/components/Footer';
import Preloader from '@/components/Preloader';
import BackToTop from '@/components/BackToTop';

function App() {
  return (
    <div className="App">
      <Preloader />
      <Header />
      <main>
        <Hero />
        <TrustStrip />
        <Services />
        <WhyUs />
        <Process />
        <Sectors />
        <Jurisdictions />
        <Technology />
        <CtaBanner />
        <ContactForm />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}

export default App;
